export const useCloseableProps = ({
  closeable,
  onClose
}) => {
  let closeableProps = {};
  if (closeable) {
    closeableProps = {
      closeable: true,
      onClose: () => onClose === null || onClose === void 0 ? void 0 : onClose()
    };
  } else {
    closeableProps = {
      closeable: false
    };
  }
  return closeableProps;
};